const selectPagination = state => state.table.pagination || {};

const selectSortBy = state => state.table.sortBy || [];

export default {
  selectPagination,
  selectSortBy,
};
